"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VColorPicker = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@blueprintjs/core");
var style_1 = require("./style");
var color_1 = __importDefault(require("color"));
var react_outside_click_handler_1 = __importDefault(require("react-outside-click-handler"));
var WOutsideClickHandler = react_outside_click_handler_1.default;
var VColorPicker = function (props) {
    var _a = (0, react_1.useState)({
        color: undefined,
        currentColor: (0, color_1.default)(props.Color)
    }), state = _a[0], setState = _a[1];
    var _b = (0, react_1.useState)(false), isOpen = _b[0], setIsOpen = _b[1];
    var pickerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        setState({
            currentColor: (0, color_1.default)(props.Color).toString(),
            color: state.color
        });
    }, [props.Color]);
    var onOutsideClick = function (e) {
        var cl = e.target.className;
        if (!props.addButton && !cl.includes('gsi-input-color')) {
            setIsOpen(false);
        }
    };
    var getPickerColor = function () {
        switch (props.typePickerColor) {
            case 'SketchPicker': {
                return (react_1.default.createElement(WOutsideClickHandler, { onOutsideClick: onOutsideClick },
                    react_1.default.createElement(style_1.SketchPickerStyled, { color: state.currentColor, onChangeComplete: handleChange, disableAlpha: props.disableAlpha }),
                    props.addButton && (react_1.default.createElement(core_1.Button, { onClick: handleClick, text: props.addButton.text, style: { fontSize: 14 }, minimal: true, large: true, fill: true, intent: props.addButton.intent }))));
            }
            case 'ChromePicker': {
                return (react_1.default.createElement(WOutsideClickHandler, { onOutsideClick: onOutsideClick },
                    react_1.default.createElement(style_1.ChromePickerStyled, { color: state.currentColor, onChangeComplete: handleChange, disableAlpha: props.disableAlpha }),
                    props.addButton && (react_1.default.createElement(core_1.Button, { onClick: handleClick, text: props.addButton.text, style: { fontSize: 14 }, minimal: true, large: true, fill: true, intent: props.addButton.intent }))));
            }
        }
    };
    var handleClick = function () {
        if (state.color) {
            props.onChange && props.onChange(state.color);
        }
        setIsOpen(false);
    };
    var handleChange = function (col) {
        var _a = col.rgb, a = _a.a, rgb = __rest(_a, ["a"]);
        setState({
            color: col,
            currentColor: (0, color_1.default)(rgb)
                .alpha(a || 1)
                .toString()
        });
    };
    var waitForHandleClick = function () {
        if (props.addButton && isOpen) {
            return;
        }
        setIsOpen(!isOpen);
    };
    return (react_1.default.createElement("div", { className: 'gsi-color-picker' }, props.disable ? (react_1.default.createElement(style_1.InputColor, { width: props.width, height: props.height, defaultColor: state.currentColor, disable: true })) : (react_1.default.createElement(core_1.Popover, { content: getPickerColor(), canEscapeKeyClose: false, isOpen: isOpen, onClosing: function () { return !props.addButton && handleClick(); }, interactionKind: 'click', captureDismiss: false, enforceFocus: true, usePortal: true, ref: pickerRef, target: react_1.default.createElement(style_1.InputColor, { className: "gsi-input-color", width: props.width, height: props.height, defaultColor: state.currentColor, onClick: waitForHandleClick }), position: props.position ? props.position : 'right', boundary: props.boundary ? props.boundary : 'scrollParent', modifiers: {
            preventOverflow: {
                enabled: true
            }
        }, onInteraction: function (nextOpenState) {
            if (!nextOpenState)
                setIsOpen(false);
        }, shouldReturnFocusOnClose: false }))));
};
exports.VColorPicker = VColorPicker;
